import { DATA } from "../constants/ActionTypes"

/**
 *
 * @type {{POPUP_STATE: 0:off 1: on, POPUP_MODULE: 'module_name'}}
 */
const initialDataState = {
    DATA_ADDRESS_PROVINCE: null
}

export default function ( state = initialDataState, action = {} ){
    let DATA_ADDRESS_PROVINCE = action.DATA_ADDRESS_PROVINCE;
    switch( action.type ){
        case DATA.DATA_ADDRESS_PROVINCE:
            return Object.assign({},state,{
                DATA_ADDRESS_PROVINCE
            });
            break;
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./common/reducers/data.js